import { useEffect, useState, useCallback } from 'react';
import { getPracticeOverview } from 'api/marketing';
import { getGPAdOverview } from 'api/operation/group';
import { IPracticeOverview } from 'types/marketing';

// isOps + organizationId route to the OPS org-scoped endpoint; without them it stays provider-scoped.
const usePracticeOverview = (
    isOps = false,
    organizationId?: number,
): [IPracticeOverview | undefined, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<IPracticeOverview>();

    const fetchData = useCallback(async () => {
        if (isOps && !organizationId) {
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            const result = isOps ? await getGPAdOverview(organizationId!) : await getPracticeOverview();
            if (!result.error && result?.data?.data) {
                setData(result.data.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [isOps, organizationId]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default usePracticeOverview;
